module.exports = "/images/intro.jpg";